// extracted by mini-css-extract-plugin
export default {"main":"FooterBtn_main__ti-1-","title":"FooterBtn_title__tH6fl","description":"FooterBtn_description__Q4Aha"};